import "./App.css";
import Layout from './Layout';
import { BrowserRouter as Router } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import React from "react";
import { useHistory } from "react-router-dom";
import "../src/assets/WebFont/ToyotaType-Book.ttf";
import "../src/sass/main.scss";
import environment from './environment';

function App() {
  const history = useHistory();
  const onAuthRequired = () => {
    history.push("/login");
  };

  const { issuerUrl, clientId, redirectUrl } = environment.prod;

  window.console.log('issuer', issuerUrl, clientId, redirectUrl)
  const oktaAuth = new OktaAuth({
    issuer: issuerUrl,
    clientId: clientId,
    redirectUri: redirectUrl,
    restoreOriginalUri: "http://localhost:3000/login",
    onAuthRequired: onAuthRequired,
    pkce: false,
  });
  return (
    <>
      <div>
        <Security
          oktaAuth={oktaAuth}
          restoreOriginalUri="http://localhost:3000"
        >
          <Router>
            <Layout />
          </Router>
        </Security>
      </div>
    </>
  );
}

export default App;



